// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeSame{\n        padding-top: 20px;\n}\n.textDetails{\n        padding-left: 20px;\n}\n.orgreleasecourse .releasecourseBoxSgl .orgTestContent .TestOne .textDetails{\n        width: 757px;\n}\n.alreadyTeacher,.classification,.mode,.operation{\n        display: flex;justify-content: center;align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
